'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;



/*****************
 ** WEBPACK FOOTER
 ** ./~/math-intrinsics/abs.js
 ** module id = 632
 ** module chunks = 73
 **/